import { type OrgEventChecklistItemDef } from 'hooks/orgEvents/orgEventAutomationHooks';
import {
  AUTOMATION_CHANNEL_OPTIONS,
  AUTOMATION_PRIORITY_OPTIONS,
} from './automationNotifyForm';

export function checklistNotifySubtitle(
  item: OrgEventChecklistItemDef
): string {
  const channels = item.notify?.notificationTypes ?? [];
  const channelLabels = channels.flatMap((value) => {
    const label = AUTOMATION_CHANNEL_OPTIONS.find(
      (opt) => opt.value === value
    )?.label;
    return label ? [label] : [];
  });
  if (channelLabels.length === 0) return 'No channels selected';
  const priority = item.notify?.priority;
  const priorityLabel = AUTOMATION_PRIORITY_OPTIONS.find(
    (opt) => opt.value === priority
  )?.label;
  const recipientCount =
    (item.notify?.userIds?.length ?? 0) + (item.notify?.teamIds?.length ?? 0);
  return [
    channelLabels.join(', '),
    priorityLabel,
    recipientCount ? `${recipientCount} recipient(s)` : null,
  ]
    .filter(Boolean)
    .join(' · ');
}

export function checklistOrgActionSubtitle(
  item: OrgEventChecklistItemDef,
  userNameByGuid: Map<string, string>
): string {
  const status = item.orgAction?.status || 'Planned';
  const poc = item.orgAction?.poc;
  const pocLabel = poc ? userNameByGuid.get(poc) || poc : 'Unassigned';
  const subTasks = item.orgAction?.checklist?.length ?? 0;
  const suffix =
    subTasks > 0 ? ` · ${subTasks} sub-task${subTasks === 1 ? '' : 's'}` : '';
  return `${status} · ${pocLabel}${suffix}`;
}

export function checklistKindLabel(item: OrgEventChecklistItemDef): string {
  return item.kind === 'send_notification' ? 'Send Notification' : 'Org Action';
}

export function checklistSubtitle(
  item: OrgEventChecklistItemDef,
  userNameByGuid: Map<string, string>
): string {
  return item.kind === 'send_notification'
    ? checklistNotifySubtitle(item)
    : checklistOrgActionSubtitle(item, userNameByGuid);
}

/** Matches on everything a row shows, so search agrees with what is visible. */
export function filterChecklistItems(
  items: OrgEventChecklistItemDef[],
  search: string,
  userNameByGuid: Map<string, string>
): OrgEventChecklistItemDef[] {
  const term = search.trim().toLowerCase();
  if (!term) return items;
  return items.filter((item) =>
    [
      item.label,
      checklistKindLabel(item),
      checklistSubtitle(item, userNameByGuid),
      item.description ?? '',
    ]
      .join(' ')
      .toLowerCase()
      .includes(term)
  );
}
